import { makeQueryStringDync, toFormUrlEncoded, errorHandlerMiddleware, setHeader, getNotInContentProvider } from "../../helper.js";

const actions = {
     vzyssodeeplink: (context, payload) => {
        console.log('vzyssodeeplink_payload', payload)
        return new Promise((resolve, reject) => {
          if (!payload) {
            reject({ error: "payload not found" });
          }
          let data = toFormUrlEncoded(payload.params);
          fetch(`${context.getters.vSmsBaseUrl}subscriberv2/v1/vzyssodeeplink`, {
            method: "POST",
            body: data,
            headers: setHeader("formUrl"),
          })
            .then((response) => errorHandlerMiddleware(response, () => actions.vzyssodeeplink(context, payload)))
    
            .then((data) => {
              resolve({ data });
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
}

export default { actions };